import http from '../../src/api/axiosConfig'

class ManageTransactions {

    prefix = '/v1/web/transaction/'

    loadTransactions() {
        return http.get(this.prefix+'all')
    }

    updateTransactionStatus(data) {
        console.log(data)
        return http.post(this.prefix+'update',data)
    }

    deleteAllNonInitTransactions() {
        return http.get(this.prefix + 'delete-all')
    }

    stopTransaction() {
        const data = {
            'stop_deposit' : true,
            'stop_withdrawal' : true
        }
        return http.post(this.prefix + 'stop', data)
    }

    enableTransaction() {
        const data = {
            'stop_deposit' : false,
            'stop_withdrawal' : false
        }
        return http.post(this.prefix + 'stop', data)
    }

    getStopTransaction() {
        return http.get(this.prefix + 'get-status')
    }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new ManageTransactions()